import React, { useState, useEffect } from "react";
import { Box, Typography, Card, CardContent, Switch, useMediaQuery } from "@mui/material";
import ReactPlayer from "react-player";
import axios from "axios";
import { useLocation } from "react-router-dom";

const InterviewDetails = () => {
    const [autoplay, setAutoplay] = useState(false);
    const [videoUrl, setVideoUrl] = useState(null);
    const location = useLocation();
    const [interviewData, setInterviewData] = useState(null);
    const [questions, setQuestions] = useState(null);
    const [selectedQuestion, setSelectedQuestion] = useState(null);

    const isSmallScreen = useMediaQuery("(max-width: 900px)");

    const queryParams = new URLSearchParams(location.search);
    const candidateId = queryParams.get("id");

    useEffect(() => {
        const fetchInterviewDetails = async () => {
            try {
                const response = await axios.post("https://api.a2ajobs.com/api/share-interview-create", {
                    candidate_id: candidateId,
                });

                if (response.data) {
                    setInterviewData(response.data.candidate);
                    setQuestions(response.data.position.questions);
                    setVideoUrl(response.data.candidate.media[0]);
                }
            } catch (err) {
            }
        };

        if (candidateId) {
            fetchInterviewDetails();
        }
    }, [candidateId]);

    return (
        <Box sx={{ display: "flex", justifyContent: "center", p: 4, bgcolor: "#f5f5f5", minHeight: "100vh" }}>
            <Box
                sx={{
                    width: isSmallScreen ? "100%" : "80%",
                    display: "flex",
                    flexDirection: isSmallScreen ? "column" : "row",
                    gap: 3,
                }}
            >
                <Box sx={{ textAlign: isSmallScreen ? "center" : "left" }}>
                    <Typography variant="h4" fontWeight="bold">
                        {`${interviewData?.first_name} ${interviewData?.last_name}`}
                    </Typography>
                </Box>

                <Box >
                    <Card sx={{ borderRadius: 2, overflow: "hidden", boxShadow: 3 }}>
                        <ReactPlayer url={videoUrl?.original_url} width="100%" height={isSmallScreen ? "250px" : "400px"} controls playing={autoplay} />
                    </Card>

                    <Card sx={{ mt: 2, p: 2, boxShadow: 2 }}>
                        <Box sx={{ display: "flex", alignItems: "center" }}>
                            <Switch checked={autoplay} onChange={() => setAutoplay(!autoplay)} />
                            <Typography variant="body1" fontWeight="bold" sx={{ ml: 1 }}>
                                Autoplay
                            </Typography>
                        </Box>
                        <Typography variant="h6" fontWeight="bold" sx={{ mt: 2 }}>
                            {selectedQuestion ? selectedQuestion.question_title : questions?.[0]?.question_title}
                        </Typography>
                        <Typography variant="body2">
                            {selectedQuestion ? selectedQuestion.full_question : questions?.[0]?.full_question}
                        </Typography>
                    </Card>
                </Box>

                <Box
                    sx={{
                        display: "flex",
                        flexDirection: isSmallScreen ? "row" : "column",
                        gap: 1,
                        overflowX: isSmallScreen ? "auto" : "unset",
                        maxWidth: isSmallScreen ? "100%" : "unset",
                        pb: isSmallScreen ? 2 : 0,
                    }}
                >
                    {questions?.map((question, index) => (
                        <Box
                            key={index}
                            sx={{
                                width: isSmallScreen ? "150px" : "200px",
                                height: "50px",
                                display: "flex",
                                alignItems: "center",
                                boxShadow: 1,
                                cursor: "pointer",
                                border: selectedQuestion?.id === question.id ? "2px solid #000" : "none",
                                flexShrink: 0,
                                p: 1,
                            }}
                            onClick={() => setSelectedQuestion(question)}
                        >
                            <Box sx={{ width: "40px", height: "40px", bgcolor: "darkred", borderRadius: "5px", mr: 1 }} />
                            <Typography variant="body1" sx={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}>
                                {question.question_title}
                            </Typography>
                        </Box>
                    ))}
                </Box>
            </Box>
        </Box>
    );
};

export default InterviewDetails;
